import { render, staticRenderFns } from "./SampleReviewCard.vue?vue&type=template&id=2a3d2a4f"
import script from "./SampleReviewCard.vue?vue&type=script&lang=js"
export * from "./SampleReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports